// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".game-area {\nbackground-color: darkcyan;\nheight:100vh;\npadding-top: 2%;\n}", "",{"version":3,"sources":["webpack://src/pages/NTIGame.css"],"names":[],"mappings":"AAAA;AACA,0BAA0B;AAC1B,YAAY;AACZ,eAAe;AACf","sourcesContent":[".game-area {\nbackground-color: darkcyan;\nheight:100vh;\npadding-top: 2%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
